(function () {
  'use strict';

  /* Picked once per page load — stable within the page (no open/close flicker)
     but a fresh random on every navigation / hard refresh. */
  var _pageIdx = null;

  /* ----------------------------------------------------------------
     populateCard
     Reads the pre-rendered JSON pool, picks a page-load-random
     product, and fills the card DOM nodes. No network cost —
     all data is pre-rendered by Liquid on the server.
  ---------------------------------------------------------------- */
  function populateCard() {
    var wrapper = document.getElementById('sps-card-wrapper');
    var dataEl  = document.getElementById('sps-product-data');
    if (!wrapper || !dataEl) {
      console.warn('[SearchSpotlight] sps-card-wrapper or sps-product-data not found in DOM. Check that the "top-10" collection exists and has products.');
      return;
    }

    var products;
    try { products = JSON.parse(dataEl.textContent || dataEl.innerText); }
    catch (e) {
      console.warn('[SearchSpotlight] Failed to parse product JSON:', e);
      return;
    }
    if (!products || products.length === 0) {
      console.warn('[SearchSpotlight] Product pool is empty — add products to the "top-10" collection.');
      return;
    }

    /* Pick once per page load — reuse if called again (e.g. theme editor reload). */
    if (_pageIdx === null || _pageIdx >= products.length) {
      _pageIdx = Math.floor(Math.random() * products.length);
    }
    var p = products[_pageIdx];

    /* Image */
    var img = document.getElementById('sps-img');
    if (img) {
      if (p.image) {
        img.src = p.image;
        img.alt = p.imgAlt || p.title;
      } else {
        var wrap = img.closest('.sps-img-wrap');
        if (wrap) wrap.style.display = 'none';
      }
    }

    /* Image link */
    var imgLink = document.getElementById('sps-img-link');
    if (imgLink) {
      imgLink.href = p.url;
      imgLink.removeAttribute('aria-hidden');
      imgLink.removeAttribute('tabindex');
    }

    /* Title */
    var titleEl = document.getElementById('sps-title');
    if (titleEl) { titleEl.textContent = p.title; titleEl.href = p.url; }

    /* Price */
    var priceEl = document.getElementById('sps-price');
    if (priceEl) { priceEl.textContent = p.price; }

    /* Desktop CTA */
    var ctaEl = document.getElementById('sps-cta');
    if (ctaEl) { ctaEl.href = p.url; }

    /* Mobile ATC — wire up variant ID */
    var atcBtn = document.getElementById('sps-atc');
    if (atcBtn && p.variantId) {
      atcBtn.setAttribute('data-variant-id', p.variantId);
    }

    /* Reveal card */
    wrapper.removeAttribute('hidden');
    wrapper.setAttribute('aria-hidden', 'false');

    /* Preload image into browser cache */
    if (p.image && 'HTMLLinkElement' in window) {
      var preload = document.createElement('link');
      preload.rel  = 'preload';
      preload.as   = 'image';
      preload.href = p.image;
      document.head.appendChild(preload);
    }
  }

  /* ----------------------------------------------------------------
     Add to Cart (mobile button)
     POSTs to Shopify's /cart/add.js. Shows tick on success,
     red flash on error — both reset after 1.5 s.
  ---------------------------------------------------------------- */
  var _cartIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" width="18" height="18" aria-hidden="true"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';

  var _atcBound = false;

  function initAddToCart() {
    /* boot() re-runs on every shopify:section:load, and each call would otherwise
       add another anonymous click listener to document, so one tap on #sps-atc
       would POST to /cart/add.js once per section reload the merchant had done. */
    if (_atcBound) return;
    _atcBound = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('#sps-atc');
      if (!btn) return;
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId || btn.disabled) return;

      btn.disabled = true;
      btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><circle cx="12" cy="12" r="9" opacity=".25"/><path d="M12 3a9 9 0 0 1 9 9" stroke-dasharray="28" stroke-dashoffset="0"><animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.7s" repeatCount="indefinite"/></path></svg>';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error(res.status);
          btn.classList.add('sps-atc--added');
          btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><polyline points="20 6 9 17 4 12"/></svg>';
          /* Refresh cart count if the theme exposes a cart bubble */
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch(function () {
          btn.classList.add('sps-atc--error');
          btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
        })
        .finally(function () {
          setTimeout(function () {
            btn.disabled = false;
            btn.classList.remove('sps-atc--added', 'sps-atc--error');
            btn.innerHTML = _cartIcon;
          }, 1500);
        });
    });
  }

  /* ----------------------------------------------------------------
     Boot
  ---------------------------------------------------------------- */
  function boot() {
    populateCard();
    initAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);

})();
